import { computed, Injectable, signal } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpService } from '@shared/services/http.service';
import { environment as env } from 'environments/environment';
import { AVATARS_ROUTE, PROFILE_ROUTE, WEBSITE_API_URL } from '@shared/constants/constants';
import { Profile } from '@shared/models/profile';
import { EntityTypes } from 'app/core/models/general-entity.types';
import { ROLES } from '@constants/role.constants';

export interface Avatar {
  value: string,
  url: string
} 

@Injectable({
  providedIn: 'root'
})
export class ProfileService {
  profile = signal<Profile | null>(null);
  avatars = signal<Avatar[]>([]);

  constructor(private httpService: HttpService) {
    this.getAvatars().subscribe({ 
      next: (res) => {
        this.avatars.set(res.data as Avatar[])
      },
      error: (error) => {
        console.error('error on getAvatars', error);
      }
    })
  }

  getAvatars(): Observable<any> {
    const url = env.baseUrl + WEBSITE_API_URL + AVATARS_ROUTE;
    return this.httpService.get<any>(url, { skipLoader: true });
  }

  saveUpdates(body: any): Observable<any> {
    const url = env.baseUrl + WEBSITE_API_URL + PROFILE_ROUTE;
    return this.httpService.put(url, body);
  }

  getProfile(): Observable<any> {
    const url = env.baseUrl + WEBSITE_API_URL + PROFILE_ROUTE;
    return this.httpService.get<any>(url);
  }

  setProfile(profile: any | null) {
    this.profile.set(profile);
    console.log('this.profile', this.profile())
  }

  getProfileImageUrl(entity: EntityTypes) {
    return computed(() => {
      let imageUrl = null;
      if (this.profile()?.imageUrl ?? '') {
        console.log('getProfileImageUrl imageUrl')
        imageUrl = this.profile()?.imageUrl ?? '';
        return imageUrl;
      } 
      
      if (this.profile()?.avatarUrl ?? '') {
        imageUrl = this.profile()?.avatarUrl ?? '';
        return imageUrl;
      }

      if (this.avatars().length > 0 ) {
        if (entity === ROLES.CANDIDATE) {
          // TODO GET FROM PROFILE
          const gender = 'other'
          imageUrl = this.avatars()?.find(av => av.value === gender)?.url ?? '';
        } else {
          imageUrl = this.avatars()?.find(av => av.value === 'employer')?.url ?? '';
        }
      }
      return imageUrl || 'https://placehold.co/52x52';
    });
  };
}
